export { default as ViewItemCarouselZoom } from './view-item-carousel-zoom';
